import { ComponentType, type JSX, memo, useEffect, useState } from 'react';

import lazy from 'common/helpers/lazy';

type DynamicImportProps<T extends {}> = {
  children: (component: Nullable<ComponentType<T>>) => JSX.Element;
  load: () => Promise<{ default: ComponentType<T> } | ComponentType<T>>;
};

const Empty = () => null;

const DynamicImport = <T extends {}>({
  load,
  children,
}: DynamicImportProps<T>) => {
  const [component, setComponent] = useState<Nullable<ComponentType<T>>>(null);

  useEffect(() => {
    lazy(load)(Empty)
      .then((result) => ('default' in result ? result.default : result))
      .then(memo)
      .then(setComponent);
  }, [load]);

  return children(component);
};

export default DynamicImport;
